module.exports = __webpack_public_path__ + "static/media/6_slogan_Culinaire-verwennerij-aan-huis.e7b94003.png";